const MAX_STRING_LENGTH = 20;

export const cropString = (str = "", limit = MAX_STRING_LENGTH): string => (
    str.length >= limit
        ? `${str.substr(0, limit)}...`
        : str
);